import { Pipe, PipeTransform } from '@angular/core';
import { App } from '@df/core/app';
import { ProcessorService } from '@df/ng/processor.service';

@Pipe({
    name: 'optionImage',
    standalone: true
})
export class OptionImagePipe implements PipeTransform {
    transform = optionImagePipe;
}

export function optionImagePipe(optionValue?: number, attributeCode?: string): string | undefined {
    const app = ProcessorService.injector.get(App);
    if (optionValue === undefined || attributeCode === undefined) {
        return undefined;
    }
    const attributeModel = app.resources.attribute.getExisting(attributeCode);
    if (!attributeModel) {
        app.logger.error('Attribute does not exist: ', attributeCode);
        return undefined;
    }
    return attributeModel.getOptionImage(optionValue);
}
